import { Injectable } from '@angular/core';
import {Observable} from "rxjs/Observable";
import {Http, Headers} from "@angular/http";
import {ConnectionService} from "./connection.service";
import {environment} from "../../environments/environment";
import {ResourceTaskTime} from "../entities/ResourceTaskTime";
import {AppConfig} from "../app.config";


@Injectable()
export class TimeplanService {

  apiUrl: string;
  
  headers(company = null): Headers {
    return this.connectionService.GetAuthorizationHeader(company);
  }

  constructor(private http: Http, private connectionService: ConnectionService, private config : AppConfig) {
    this.apiUrl = config.getConfig('endPointApiUrl');
  }


  createTimePlan(resourceTaskTime: ResourceTaskTime): Observable<ResourceTaskTime> {
    let url = this.apiUrl + 'api/TimePlan/Create';
    return this.http
      .post(url, JSON.stringify(resourceTaskTime), {headers: (this.headers())})
      .map(response => response.json() as ResourceTaskTime)
      .catch(err =>{throw new Error('Valid token not returned'); });
  }

  updateTimePlan(resourceTaskTime: ResourceTaskTime)
  {
    let url = this.apiUrl + 'api/TimePlan/Update';
    return this.http
      .put(url, JSON.stringify(resourceTaskTime), {headers: (this.headers())})
      .map(response => response.json() as ResourceTaskTime);
  }

  removeTimePlan(resourceTaskTime: ResourceTaskTime)
  {
    let url = this.apiUrl + 'api/TimePlan/Delete';
    return this.http
      .put(url, JSON.stringify(resourceTaskTime), {headers: (this.headers())})
      .map(response => response.json() as ResourceTaskTime);
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/timeplan.service.ts